<template>
  <app-base-main no-padding>
    <template #filter-group>
      <app-filter-group :reset="false" :query="false">
        <gj-warehouse-select :self="false" multiple v-model="filter.warehouseIds" placeholder="仓库" width="170px"></gj-warehouse-select>
        <gj-input v-model="inputValue" :width="'200px'" placeholder="请搜索MSKU" @blur="$gjNoticeQuery"></gj-input>
        <gj-radio-group v-model="filter.state" :options="radioOptions"></gj-radio-group>
      </app-filter-group>
    </template>
    <template #table>
      <gj-table
        :data="data"
        :columns="columns"
        :height="400"
        :adapt-height="false"
        :index="false"
        :pagination="pagination"
        :loading="loading"
        @page-change="$gjNoticeQuery"
      ></gj-table>
    </template>
  </app-base-main>
</template>

<script>
import { queryMixin } from "@/minxins";
import { storageCostBatchRecalculateTaskPage } from "@/api/finance";

export default {
  name: "finance-profit-report-task",
  mixins: [queryMixin],
  data() {
    return {
      data: [],
      radioOptions: [
        { id: 'success', text: "成功" },
        { id: 'processing', text: "处理中" },
        { id: 'fail', text: "失败" },
      ],
      columns: [
        { id: "warehouseName", header: "仓库", field: "warehouseName", width: "130px", },
        { id: "msku", header: "MSKU", field: "msku", width: "130px", },
        { id: "opUser", header: "操作用户", field: "createUserName", width: "100px", },
        { id: "createTime", header: "操作时间", field: "createTime", width: "165px", },
        { id: "content", header: "重算时间区间", field: "dateInterval", width: "200px", },
        { id: "finishTime", header: "任务结束时间", field: "finishTime", width: "165px", },
      ],
      filter: {
        warehouseIds: null,
        state: 'processing',
      },
      inputValue: null,
      useCache: false,
    };
  },
  watch: {
    filter: {
      handler: "$gjNoticeQuery",
      deep: true,
    }
  },
  methods: {
    $gjQueryInitParams() {
        return {
          filter: {
            warehouseIds: null,
            state: 'processing',
          },
          inputValue: null
        };
      },
    $gjQuery() {
      this.loading = true;
      storageCostBatchRecalculateTaskPage({
        model: {
          status: this.filter.state,
          msku: this.inputValue,
          warehouseIdList: this.filter.warehouseIds,
        },
        ...this.queryPagination,
        ...this.querySort,
      })
        .then((data) => {
          this.data = data.records;
          this.pagination = this.getPagination(data);
        })
        .complete(() => (this.loading = false));
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.table-shadow {
  box-shadow: unset;
}
</style>
